import { render, staticRenderFns } from "./slcp-form.vue?vue&type=template&id=31d2c345&"
import script from "./slcp-form.vue?vue&type=script&lang=js&"
export * from "./slcp-form.vue?vue&type=script&lang=js&"
import style0 from "./slcp-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports